import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=01aa420c&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"
import style0 from "./nav.vue?vue&type=style&index=0&id=01aa420c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa420c",
  null
  
)

export default component.exports